import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Pages/Config";
import { IoCall, IoLogoWhatsapp } from "react-icons/io5";

const ContactInfo = ({ buyerId, itemId, productName, productType, }) => {
  const [phone, setPhone] = useState(null);
  const [code, setcode] = useState(null);
  const [name, setName] = useState(null);
  useEffect(() => {
    const fetchBuyerContact = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/get_user_by_id.php?id=${buyerId}&t=${Date.now()}`
        );

        console.log("contact", res)
        if (res.data.success && res.data.data) {
          const { phone_num } = res.data.data;
          setPhone(phone_num || null);
          setcode(res.data.data.country_code || null);
          setName(res.data.data.name || null);

          console.log("number", res.data.data.country_code);
        } else {
          setPhone(null);
        }
      } catch (error) {
        console.error("Failed to fetch contact", error);
        setPhone(null);
      }
    };

    if (buyerId) {
      fetchBuyerContact();
    }
  }, [buyerId]);

  if (!phone) {
    return;
  }
  const productLink = `https://fasttrade.com/detail/${itemId}`;


  let message = "";

  if (productType === "Won") {
    message = `Hello ${name},
 
I have successfully won your product on *FastTrade*.

📦 Product: ${productName}

🔗 View Product:
${productLink}

I am the buyer of this item. Please contact me on WhatsApp so we can discuss the next steps, such as payment and delivery details.

Thank you.`;
  } else if (productType === "Sold") {
    message = `Hello ${name},

Congratulations! 🎉  
Your purchase on *FastTrade* has been successfully confirmed.

📦 Product: ${productName}.

🔗 View Product:
${productLink}

I am the seller of this item. Please contact me on WhatsApp so we can discuss the next steps such as delivery and payment details.

Thank you for choosing FastTrade.
`;
  }




  return (
    <>
      {/* Call Button */}
      <button
        onClick={() => (window.location.href = `tel:+${code}${phone}`)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          backgroundColor: "#2563eb",
          color: "#fff",
          padding: "10px 16px",
          borderRadius: "12px",
          border: "none",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          cursor: "pointer",
          flex: "1 1 120px",
          fontSize: "14px",
        }}
      >
        <IoCall size={20} />
        <span className="soical_button">Call</span>
      </button>

      {/* WhatsApp Button */}
      <button
        onClick={() =>
          window.open(
            `https://wa.me/${code}${phone}?text=${encodeURIComponent(message)}`,
            "_blank"
          )
        }
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          backgroundColor: "#16a34a",
          color: "#fff",
          padding: "10px 16px",
          borderRadius: "12px",
          border: "none",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          cursor: "pointer",
          flex: "1 1 120px",
          fontSize: "14px",
        }}
      >
        <IoLogoWhatsapp size={20} />
        <span className="soical_button">WhatsApp</span>
      </button>

    </>
  );
};

export default ContactInfo;
